import { CBadge, CFooter, CNavLink } from '@coreui/react-pro'
import { default as React, memo } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'
import 'simplebar/dist/simplebar.min.css'
import { isUserDataSaved } from 'src/actions'
import UseSweetAlert from 'src/hooks/useSweetAlert'
import { isDarkTheme } from 'src/selectors/ThemeSelector'
import { isNotSaved } from 'src/selectors/UserSelector'
import navigation from '../_navMobile'

const AppFooterMobile = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const dispatch = useDispatch()
  const { t } = useTranslation('menu')
  const [SweetAlert, showSweetAlert] = UseSweetAlert()
  const isDataNotSaved = useSelector(isNotSaved)
  const auth = useSelector((state) => state.auth)
  const isDark = useSelector(isDarkTheme)
  const permissions = auth.permissions.map((permission) => permission.name)

  const authNav = navigation?.filter((n) =>
    n.permissions ? n.permissions?.find((permission) => permissions.includes(permission)) : false,
  )

  const userPermissions = auth.permissions.map((permission) => permission.name)

  const navLink = (name, icon, badge) => {
    return (
      <span className="d-flex flex-column align-items-center justify-content-center my-1">
        {icon && icon}
        {name && t(name)}
        {badge && (
          <CBadge color={badge.color} className="ms-auto">
            {badge.text}
          </CBadge>
        )}
      </span>
    )
  }

  const navItem = (item, index) => {
    const { component, name, badge, permissions, icon, ...rest } = item
    const Component = component
    let isShow = true
    if (permissions) {
      if (!userPermissions.find((permission) => permissions.includes(permission))) {
        isShow = false
      }
    }

    const handleClick = (rest) => {
      if (isDataNotSaved) {
        showSweetAlert({
          message: t('navigate-without-save'),
          showCancel: true,
          onConfirm: () => {
            navigate(rest.to)
            dispatch(isUserDataSaved(false))
          },
        })
      } else {
        navigate(rest.to)
      }
    }

    return (
      isShow && (
        <Component
          className={`footer-item ${
            location.pathname?.includes(rest.to)
              ? isDark
                ? 'mobile-active-dark'
                : 'mobile-active-light'
              : ''
          }`}
          key={index}
        >
          <CNavLink onClick={() => handleClick(rest)}>{navLink(name, icon, badge)}</CNavLink>
        </Component>
      )
    )
  }

  return (
    <>
      <SweetAlert />
      <CFooter>
        <div className={`footer-list ${isDark ? 'bg-footer-dark' : 'bg-light text-dark'}`}>
          {authNav && authNav.map((item, index) => <div key={index}>{navItem(item, index)}</div>)}
        </div>
      </CFooter>
    </>
  )
}

export default memo(AppFooterMobile)
